import { render, staticRenderFns } from "./EmailAlertList.vue?vue&type=template&id=639d5874&scoped=true&"
import script from "./EmailAlertList.vue?vue&type=script&lang=js&"
export * from "./EmailAlertList.vue?vue&type=script&lang=js&"
import style0 from "./EmailAlertList.vue?vue&type=style&index=0&id=639d5874&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639d5874",
  null
  
)

export default component.exports